import React, { useState } from "react";
import { Label, Input } from "reactstrap";

const ImageOne = ({ validation, imageOne, setImageOne }) => {
  const handleImageOneChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 300 * 1024) {
      const imageURL = URL.createObjectURL(file);

      setImageOne(imageURL);
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64ImageString = event.target.result;
        validation.setFieldValue("imgOne", base64ImageString);
        validation.setFieldError("imgOne", ""); // Clear any previous error
      };
      reader.readAsDataURL(file);
    } else {
      validation.setFieldError(
        "imgOne",
        "File size should be less than or equal to 200 KB"
      );
    }
  };

  return (
    <div className="text-left">
      <div className="position-relative d-inline-block">
        <div className="position-absolute bottom-0 end-0">
          <Label htmlFor="customer-image-input" className="mb-0">
            <div className="avatar-xs cursor-pointer">
              <div
                className="avatar-title bg-light border rounded-circle text-muted "
                style={{ cursor: "pointer" }}
              >
                <i className="ri-image-fill p-1 "></i>
              </div>
            </div>
          </Label>
          <Input
            name="imgOne"
            className="form-control d-none"
            id="customer-image-input"
            type="file"
            accept="image/png, image/gif, image/jpeg"
            // onChange={validation.handleChange}
            onChange={handleImageOneChange}
            onBlur={validation.handleBlur.imgOne}
            invalid={
              validation.touched.imgOne && validation.errors.imgOne
                ? true
                : false
            }
          />
        </div>
        <div className="avatar-lg p-1">
          <div
            className="avatar-title bg-light"
            style={{ width: "130px", height: "120px", borderRadius: "5px" }}
          >
            <img
              src={validation.values.imgOne || imageOne}
              alt=""
              id="customer-img"
              className="avatar-lg object-cover"
              style={{ height: "100%", borderRadius: "5px" }} // Set the dimensions and border radius here
            />
          </div>
        </div>
      </div>
      {validation.errors.imgOne && validation.touched.imgOne && (
        <div className="text-danger">{validation.errors.imgOne}</div>
      )}
      <div className="text-muted fs-12">
        Image size should be less than 70KB
      </div>
    </div>
  );
};

export default ImageOne;
